import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Typography, TreeSelect, Form, Row, Col, Spin, Button, message } from 'antd';
import { setIndexPage, publishIndexPage } from '../../../../actions/pages.actions';
import { isEmpty, set, merge } from 'lodash';
import { pageUtils } from '../../../../utils/common';
import './Forms.css';

const { Text } = Typography;

const IndexForm = props => {
    const { getFieldDecorator } = props.form;
    const { pages, indexUpdating, indexSuccess, error } = props;
    const [processing, setProcessing] = useState(false);

    const searchPageBlock = page => {
        let publishedPages = [];

        for (let key in page.subpages) {
            if (page.subpages.hasOwnProperty(key)) {
                publishedPages.push(...searchPageBlock(page.subpages[key]));
            }
        }

        if (page.hasOwnProperty('statusProps')) {
            if (page.statusProps.hasOwnProperty('publishLocation')) {
                publishedPages.push({ id: page.statusProps.publishLocation, title: page.title });
            }
        }

        return publishedPages;
    };
    const toHierarchicalPagesStructure = pages => {
        const rootPages = pageUtils.objectifyPages(pages.filter(page => page.id.split('/').length === 2));
        const otherPagesArr = pages.filter(page => page.id.split('/').length > 2);

        otherPagesArr.forEach(subPage => {
            const hierarchicalSubpage = set({}, '/' + pageUtils.getObjectStructureFromPath(subPage.id, false), subPage);
            merge(rootPages, hierarchicalSubpage);
        });

        return Object.values(rootPages);
    };

    const getPublishedPages = pages => {
        let publishedPages = [];

        for (let i = 0; i < pages.length; i++) {
            publishedPages.push(...searchPageBlock(pages[i]));
        }

        return publishedPages;
    };

    useEffect(() => {
        if (indexUpdating === false) {
            if (error) {
                message.error('Something went wrong when saving the index page setting, please try again.');
                setProcessing(false);
            } else {
                if (indexSuccess) {
                    message.success('Save successful.');
                    setProcessing(false);
                }
            }
        }
    }, [indexUpdating, indexSuccess, error]);

    const saveSettings = e => {
        e.preventDefault();

        const doPublish = document.activeElement.value === 'true';

        props.form.validateFields((err, values) => {
            if (!err) {
                if (doPublish) {
                    values.savedIndex = props.index;
                    props.publishIndexPage(values);
                } else {
                    props.setIndexPage(values);
                }
                setProcessing(true);
            }
        });
    };

    const Spinner = props => {
        if (props.visible) {
            return (
                <div className="spinner">
                    <Spin />
                </div>
            );
        }
        return '';
    };

    const convertPageToTreeData = page => {
        let treeData = { title: page.title, value: page.id, key: page.id, children: [] };
        if (!isEmpty(page.subpages)) {
            for (let subpage in page.subpages) {
                treeData.children.push(convertPageToTreeData(page.subpages[subpage]));
            }
        }
        return treeData;
    };

    return (
        <div className="settingsBlock" data-title="Index page">
            <Form onSubmit={saveSettings} layout="vertical">
                <Row gutter={16} style={{ display: 'flex' }}>
                    <Col span={14}>
                        <Form.Item label="Index page" style={{ marginBottom: 0 }}>
                            {getFieldDecorator('index', {
                                initialValue: props.index,
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please select an index page'
                                    }
                                ]
                            })(
                                <TreeSelect
                                    name="index"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    treeData={toHierarchicalPagesStructure(getPublishedPages(pages)).map(convertPageToTreeData)}
                                    placeholder="Select the index page"
                                    treeDefaultExpandAll
                                    showSearch
                                    treeNodeFilterProp="title"
                                />
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={10} style={{ marginTop: '1.5rem', marginBottom: 'auto' }}>
                        <Text type="secondary">
                            Select the page that will appear as the index page, this is the page that will be shown when no page path has be probided in the url. Only published pages are selectable.
                        </Text>
                    </Col>
                </Row>

                <div className="savePublishGroup">
                    <Button.Group>
                        <Button size="small" type="primary" htmlType="submit" value={false} icon="save" title="Save" disabled={processing} />
                        <Button size="small" type="success" htmlType="submit" value={true} icon="cloud-upload" title="Publish" disabled={processing} />
                    </Button.Group>
                </div>
            </Form>
            <Spinner visible={processing} />
        </div>
    );
};

const mapStateToProps = state => ({
    pages: state.pages.pages,
    index: state.pages.index,
    indexUpdating: state.pages.indexUpdating,
    indexSuccess: state.pages.indexSuccess,
    error: state.pages.error
});
const mapDispatchToProps = {
    setIndexPage,
    publishIndexPage
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create({ name: 'index_form' })(IndexForm));
